module.exports = __webpack_public_path__ + "static/media/bronze.c893d8da.png";